<div class="budget-table-container" *transloco="let t; prefix: 'costTracking.budgetTable'">
  <div class="table-container">
    <div class="table-inner">
      <table class="budget-table">
        <thead>
          <tr>
            <th class="asset">{{ t('assets') }}</th>
            <th class="category">{{ t('budgetCategory') }}</th>
            <th class="annual">{{ t('annualBudget') }}</th>
            <th class="monthly">{{ t('monthlyBudget') }}</th>
            <th class="notes">{{ t('notes') }}</th>
            <th class="actions">{{ t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr class="state-row">
              <td colspan="6">
                <div class="spinner-border"></div>
              </td>
            </tr>
          } @else if (!budgets.length) {
            <tr class="state-row">
              <td colspan="6">
                <app-empty-state></app-empty-state>
              </td>
            </tr>
          } @else {
            @for (item of budgets; track item.id) {
              <tr class="budget-row">
                <td class="asset">{{ assetLabel(item) }}</td>
                <td class="category">{{ item.budgetCategoryName | lookupLabel:budgetCategoryLabels }}</td>
                <td class="annual">{{ formatCost(item.annualBudget) }}</td>
                <td class="monthly">{{ formatCost(item.monthlyBudget) }}</td>
                <td class="notes" [title]="item.notes ?? ''">{{ item.notes || '--' }}</td>
                <td class="actions">
                  <div ngbDropdown class="action-dropdown" container="body" placement="bottom-end top-end">
                    <button type="button" class="btn btn-link action-btn" ngbDropdownToggle
                      [attr.aria-label]="t('actionsFor', { asset: assetLabel(item) })">
                      <i class="ph ph-dots-three-vertical"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu action-dropdown-menu">
                      <button type="button" ngbDropdownItem (click)="onEditClick(item)">{{ 'common.edit' | transloco }}</button>
                      <button type="button" ngbDropdownItem class="text-danger" (click)="onDeleteClick(item)">{{ 'common.delete' | transloco }}</button>
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <app-table-footer
      [page]="page"
      [pageSize]="pageSize"
      [totalCount]="totalCount"
      [totalPages]="totalPages"
      (pageChange)="goToPage($event)">
    </app-table-footer>
  </div>
</div>